import { Injectable } from "@angular/core";

import { INavPill } from "../../core/interfaces/nav-pill.interface";

import { DocumentTypeEnum } from "../../core/enums/document-type.enum";
import { InitialNavPillsEnum } from "../../core/enums/initial-nav-pills.enum";

@Injectable({
  providedIn: "root",
})
export class InitialNavPillsDataService {
  getInitialNavPills(): INavPill[] {
    return [
      {
        active: true,
        id: InitialNavPillsEnum.LOGIN_CUSTOMER,
        text: "Cédula de ciudadanía",
        value: DocumentTypeEnum.CC,
      },
      {
        active: false,
        id: InitialNavPillsEnum.LOGIN_CUSTOMER,
        text: "Cédula de extranjería",
        value: DocumentTypeEnum.CE,
      },
    ];
  }
}
